export const randomPhrases = [
  'Been a while, crocodile',
  'Working hard or hardly working?',
  'What do you call a toothless bear? A gummy bear 🤭',
  "What's up, buttercup?",
  'Fun fact. Stop signs used to be yellow.',
  'Fun fact. New York was briefly called New Orange 🍊',
  'Fun fact. Some cats are actually allergic to humans.',
  "What's crackalackin'?",
  'I like that colour on you!',
  'So...the weather. Am I right?',
  "This place hasn't been the same without you.",
  "We've been completely lost without you",
];
